import StorageService from './storage-service';

export default class AuthService {
  static ACCESS_TOKEN = 'core/accessToken';

  static setAccessToken(accessToken: string): void {
    return StorageService.setItem(this.ACCESS_TOKEN, accessToken);
  }

  static getAccessToken(): string | null {
    return StorageService.getItem(this.ACCESS_TOKEN);
  }
}
